import { BaseIngredientTabProps } from 'components/desktop/BaseIngredient/BaseIngredientComponent';
import 'components/desktop/BaseIngredient/BaseIngredientComponent.scss';
import { BaseIngredientCaloriesCard } from 'components/desktop/BaseIngredient/Cards/BaseIngredientCaloriesCard';
import { BaseIngredientCategoriesCard } from 'components/desktop/BaseIngredient/Cards/BaseIngredientCategoriesCard';
import { BaseIngredientNutriScoreCard } from 'components/desktop/BaseIngredient/Cards/BaseIngredientNutriScoreCard';
import { BaseIngredientNutritionDiagramCard } from 'components/desktop/BaseIngredient/Cards/BaseIngredientNutritionDiagramCard';
import BaseIngredientNutrients from 'components/desktop/BaseIngredient/LanguageInput/BaseIngredientNutrients';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import ENTITLEMENTS from 'enums/entitlements';

const TabNutrients = (props: BaseIngredientTabProps) => {
	return (
		<div className="row mt-4">
			<div className="col-md-4 col-xl-3 col-sm-12 col-12 sidebar">
				<BaseIngredientCategoriesCard {...props} />
				<BaseIngredientCaloriesCard {...props} />
				<RenderIf entitlements={[ENTITLEMENTS.NUTRI_SCORE]}>
					<BaseIngredientNutriScoreCard {...props} />
				</RenderIf>
				<BaseIngredientNutritionDiagramCard {...props} />
			</div>

			<div className="col-md-8 col-xl-9 col-sm-12 col-12">
				<BaseIngredientNutrients
					characteristic={props.state.characteristic}
					allNutrients={props.data.nutrients}
					nutrients={props.state.nutrientValues}
					setNutrients={props.handlers.setNutrientValues}
				/>
			</div>
		</div>
	);
};

export default TabNutrients;
